export default [
    {
        path: "add-rateplan",
        name: "addrateplans",
        component: () =>
            import(
            /* webpackChunkName: "AddSingleSubscriber" */ "../pages/ratePlan/AddRatePlan.vue"
            ),
        meta: {
            title: `Add Rateplan`,
        },
    },
    {
        path: "rateplan-lists",
        name: "rateplanlists",
        component: () =>
            import(
            /* webpackChunkName: "AddSingleSubscriber" */ "../pages/ratePlan/RatePlan.vue"
            ),
        meta: {
            title: `Rateplan List`,
        },
    },
    {
        path: "/edit-rateplans/:id",
        name: "editrateplan",
        component: () =>
            import(
            /* webpackChunkName: "AddSingleSubscriber" */ "../pages/ratePlan/EditRatePlan.vue"
            ),
        meta: {
            title: `Edit Rateplan`,
        },
    },
    {
        path: "/rateplans/:id",
        name: "saleingrateplans",
        component: () =>
            import(
            /* webpackChunkName: "AddSingleSubscriber" */ "../pages/ratePlan/SaleingRatePlan.vue"
            ),
        meta: {
            title: `Rate Plan Details`,
        },
    },
    {
        path: "/add-sale-rate/:id",
        name: "addsalerate",
        component: () =>
            import(
            /* webpackChunkName: "AddSingleSubscriber" */ "../pages/ratePlan/AddSaleRate.vue"
            ),
        meta: {
            title: `Saleing Rateplan`,
        },
    },
    {
        path: "/edit-sale-rate/:id",
        name: "editsalerates",
        component: () =>
            import(
            /* webpackChunkName: "AddSingleSubscriber" */ "../pages/ratePlan/EditSaleRate.vue"
            ),
        meta: {
            title: `Saleing Rateplan`,
        },
    }
];
